import styled from "styled-components";

interface NewFlagProps {
    type: 'product' | 'building' | 'tech-sector-city' | 'tech-sector-building';
    animationDelay?: number;
    isBottom?: boolean;
}

const NewFlag = styled.div<NewFlagProps>`
    position: absolute;
    display: inline-block;
    top: -13px;
    left: 50%;
    transform: translateX(-50%);
    background: ${(props) => props.theme.colors.signal};
    text-transform: uppercase;
    padding: 2px 2px 13px;
    font-size: 8px;
    font-weight: 700;
    webkit-mask: radial-gradient(circle 12px at bottom center, transparent 100%, black 100%);
    mask: radial-gradient(circle 12px at bottom center, transparent 100%, black 100%);

    ${(props) =>
        props.type === 'building'
            ? `
        top: ${props.isBottom ? '55px' : '-40px'};
        left: 30px;
        padding: 2px 7px;
        color: #fff;
        font-size: ${props.theme.typography.xs};
        webkit-mask: none;
        mask: none;
    `
            : ''};

    ${(props) =>
        props.type === 'tech-sector-city'
            ? `
        top: 20px;
        padding: 2px 1px;
        padding-bottom: 20px;
        z-index: -1;
        font-size: ${props.theme.typography.xs};
        clip-path: polygon(0 0,100% 0,100% 100%,88% 83%,75% 73%,56% 68%,42% 68%,25% 75%,12% 86%,0 100%);
    `
            : ''};

    ${(props) =>
        props.type === 'tech-sector-building'
            ? `
            @keyframes fadeIn {
                0% { opacity: 0; }
                100% { opacity: 1; }
            }
            animation: fadeIn 0.2s ease-out forwards;
            animation-delay: ${'1.' + (props.animationDelay ?? 0 + 2) + 's'};
            opacity: 0;
            width: 100%;
    `
            : ''};

    @media ${(props) => props.theme.screens.lg} {
        top: -28px;
        padding: 3px 1px 25px;
        font-size: ${(props) => props.theme.typography.sm};
        webkit-mask: radial-gradient(circle 25px at bottom center, transparent 100%, black 100%);
        mask: radial-gradient(circle 16px at bottom center, transparent 100%, black 100%);

        ${(props) =>
            props.type === 'building'
                ? `
        top: ${props.isBottom ? '85px' : '-69px'};
        left: 42px;
        padding: 0px 6px;
        color: #fff;
        font-size: ${props.theme.typography.md};
        webkit-mask: none;
        mask: none;
        `
                : ''};
    }
`;

export default NewFlag;
